//#region src/kiosk_ordering_mode.ts
var KioskOrderingMode = /* @__PURE__ */ function(KioskOrderingMode) {
	KioskOrderingMode["Full"] = "full";
	KioskOrderingMode["ScannerOnly"] = "scanner-only";
	return KioskOrderingMode;
}(KioskOrderingMode || {});
//#endregion
export { KioskOrderingMode };

//# sourceMappingURL=kiosk_ordering_mode.js.map